import MayoLanding from "../common/MayoLanding";

import doctorImage from "../../../../assets/Mayo/Doctor1.png";

export default function MayoLanding2TAVR() {
  return <MayoLanding
    title={"Hi,"}
    text={"Before the TAVR procedure, we want to ensure you have all the necessary information about how to prepare well. Your understanding plays a vital role in your recovery journey!"}
    image={doctorImage}
    buttonText={"Start"}
    navigateTo={"/patient/mayo/video_page2_tavr"}
    postAnalyticType="messageOpnedTAVR"
  />
}